var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("NsSelect", {
    staticClass: "df-select",
    attrs: {
      label: _vm.schema.label,
      hint: _vm.schema.hint,
      items: _vm.schema.items,
      "item-text": _vm.schema.itemText,
      "item-value": _vm.schema.itemValue,
      rules: _vm.rules,
      "menu-props": "{ auto: true }",
      type: "text",
    },
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }